import React, { useState } from "react";
import "./ImageCarousel.css";

function ImageCarousel({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    const newIndex = (currentIndex - 1 + images.length) % images.length;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const newIndex = (currentIndex + 1) % images.length;
    setCurrentIndex(newIndex);
  };

  return (
    <div className="carousel">
      <button className="carousel-button left" onClick={goToPrevious}>
        ❮
      </button>

      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex}`}
        className="carousel-image"
      />

      <button className="carousel-button right" onClick={goToNext}>
        ❯
      </button>
    </div>
  );
}

export default ImageCarousel;
